export const IMAGE_LIMITS = Object.freeze({
  maxBytes: 10 * 1024 * 1024,
  maxPixels: 20_000_000,
  maxDimension: 16384,
  decoderSeconds: 10,
});
export const IMAGE_EDGES = Object.freeze([320, 640, 1280]);
export function requireImageDimensions(width, height) {
  if (
    !Number.isSafeInteger(width) ||
    !Number.isSafeInteger(height) ||
    width <= 0 ||
    height <= 0 ||
    width > IMAGE_LIMITS.maxDimension ||
    height > IMAGE_LIMITS.maxDimension ||
    width * height > IMAGE_LIMITS.maxPixels
  )
    throw new TypeError('image_too_large');
}
